import React, { useEffect, useState } from "react";

import { Box, CircularProgress } from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "./AuthContext";
import { CookieKey, getCookie } from "../../hooks/useCookie";

interface Props {
  children: JSX.Element;
}

function PrivateRoute({ children }: Props) {
  const { authenticated, login } = useAuth();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthentication = async () => {
      const token = getCookie(CookieKey.JWT_TOKEN);

      if (token && !authenticated) {
        login();
      }
      setIsLoading(false);
    };

    checkAuthentication();
  }, [location.pathname]);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          width: "100vw",
          backgroundColor: (theme) => theme.palette.grey[100],
        }}
      >
        <CircularProgress size={36} sx={{ color: "#2563eb" }} />
      </Box>
    );
  }

  if (!authenticated && !["/login", "/register"].includes(location.pathname)) {
    const ref = new URLSearchParams(location.search).get("ref");
    return (
      <Navigate to={ref ? `/login?ref=${encodeURIComponent(ref)}` : "/login"} />
    );
  }

  if (authenticated && ["/login", "/register"].includes(location.pathname)) {
    return <Navigate to="/episodes" />;
  }

  return children;
}

export default PrivateRoute;
